import { PhoneCall } from 'lucide-react'
import { useSettings } from '@/modules/settings-api'

export function HotlineBadge() {
  const { data: settings } = useSettings()
  return (
    <div className="flex items-center gap-3 shrink-0">
      <div className="w-11 h-11 rounded-full bg-brand-50 flex items-center justify-center text-brand-600">
        <PhoneCall className="w-5 h-5" />
      </div>
      <div className="leading-tight">
        <div className="text-xs text-muted">Hotline tư vấn</div>
        <div className="text-lg font-bold text-brand-600">{settings.hotline}</div>
      </div>
    </div>
  )
}
